/**
 * Singleton loading service.
 * Tracks in-flight API requests and notifies subscribers.
 * Used by Axios interceptors and GlobalLoadingBar.
 */

let pendingCount = 0;
type Listener = (isLoading: boolean) => void;
const listeners = new Set<Listener>();

export const loadingService = {
  subscribe(fn: Listener): () => void {
    listeners.add(fn);
    return () => listeners.delete(fn);
  },
  increment(): void {
    pendingCount++;
    if (pendingCount === 1) listeners.forEach(fn => fn(true));
  },
  decrement(): void {
    pendingCount = Math.max(0, pendingCount - 1);
    if (pendingCount === 0) listeners.forEach(fn => fn(false));
  },
  reset(): void {
    pendingCount = 0;
    listeners.forEach(fn => fn(false));
  },
};
